import { render, staticRenderFns } from "./OrganismAttachmentManagement.vue?vue&type=template&id=7f95508a&scoped=true&"
import script from "./OrganismAttachmentManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismAttachmentManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAttachmentManagement.vue?vue&type=style&index=0&id=7f95508a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95508a",
  null
  
)

export default component.exports